import _extends from "babel-runtime/helpers/extends";
import _objectWithoutProperties from "babel-runtime/helpers/objectWithoutProperties";
import React from "react";
import styled, { keyframes, css } from "styled-components";

import { responsiveImg } from "../../style/util";

var Button = styled(function (_ref) {
  var size = _ref.size,
      color = _ref.color,
      src = _ref.src,
      alt = _ref.alt,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? "button" : _ref$type,
      props = _objectWithoutProperties(_ref, ["size", "color", "src", "alt", "type"]);

  return React.createElement(
    "button",
    _extends({ type: type }, props),
    React.createElement("img", { src: src, alt: alt })
  );
}).withConfig({
  componentId: "xtsvp6-0"
})(["background:transparent none;border:1px solid ", ";border-radius:", "px;box-sizing:border-box;color:", ";display:inline-block;height:", "px;line-height:", "px;padding:", "px;text-align:center;text-decoration:none;width:", "px;img{", ";width:100%;}"], function (_ref2) {
  var color = _ref2.color;
  return color || "#fff";
}, function (_ref3) {
  var size = _ref3.size;
  return size / 2;
}, function (_ref4) {
  var color = _ref4.color;
  return color || "#fff";
}, function (_ref5) {
  var size = _ref5.size;
  return size;
}, function (_ref6) {
  var size = _ref6.size;
  return size / 2;
}, function (_ref7) {
  var size = _ref7.size;
  return size / 4;
}, function (_ref8) {
  var size = _ref8.size;
  return size;
}, responsiveImg());
export { Button };
//# sourceMappingURL=style.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/components/RoundedButton/style.js
// module id = 508
// module chunks = 0